import { useUserLocalSettings } from '@euler/app/flows/settings/functions/useUserLocalSettings';
import { TableView } from '@euler/components/TableView';
import { useStoreFeature } from '@euler/functions/entitlements/useStoreFeature';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { StoreFeature } from '@euler/model/enum';
import { ScrollView } from 'react-native';
import { Cell2 as Cell, Section } from '../components/SettingsTable';

export const GeneralSettingsScreen = wrapNavigatorScreen(
  () => {
    const { rpx } = useResponsiveContext();
    const [userSettings, updateUserSettings] = useUserLocalSettings();
    const isQuotationEnabled = useStoreFeature(StoreFeature.Quotation).enabled;

    return (
      <ScrollView
        contentContainerStyle={{
          paddingTop: rpx(15),
          paddingBottom: rpx(15),
        }}
      >
        <TableView>
          <Section>
            <Cell
              title="未保存施工提醒"
              isSwitch
              switchOn={!userSettings?.noAlertBeforeNavigateAwayConstructionJob}
              onSwitchChange={value =>
                updateUserSettings({
                  noAlertBeforeNavigateAwayConstructionJob: !value,
                })
              }
              switchStyle={{ marginRight: rpx(10) }}
            />

            <Cell
              title="未保存交车提醒"
              isSwitch
              switchOn={!userSettings?.noAlertBeforeNavigateAwayDeliveryCheck}
              onSwitchChange={value =>
                updateUserSettings({
                  noAlertBeforeNavigateAwayDeliveryCheck: !value,
                })
              }
              switchStyle={{ marginRight: rpx(10) }}
            />

            <Cell
              title="派工时记住上次派工对象"
              isSwitch
              switchOn={
                userSettings?.rememberLastServiceSubjectAssignment === true
              }
              onSwitchChange={value =>
                updateUserSettings({
                  rememberLastServiceSubjectAssignment: value,
                })
              }
              switchStyle={{ marginRight: rpx(10) }}
            />

            <Cell
              title="使用旧版任务卡片"
              note="任务列表和服务记录列表恢复为旧版样式"
              noteStyle={{
                fontSize: rpx(11),
                lineHeight: rpx(15),
                marginTop: rpx(2),
                marginLeft: rpx(8),
              }}
              isSwitch
              switchOn={userSettings?.preferLegacyTaskCard === true}
              onSwitchChange={value =>
                updateUserSettings({
                  preferLegacyTaskCard: value,
                })
              }
              switchStyle={{ marginRight: rpx(10) }}
            />

            {isQuotationEnabled && (
              <Cell
                title="未保报价单提醒"
                isSwitch
                switchOn={!userSettings?.noAlertBeforeNavigateAwayQuotationForm}
                onSwitchChange={value =>
                  updateUserSettings({
                    noAlertBeforeNavigateAwayQuotationForm: !value,
                  })
                }
                switchStyle={{ marginRight: rpx(10) }}
              />
            )}
          </Section>

          <Section title="语音播报">
            <Cell
              title="自动播报服务备注"
              isSwitch
              switchOn={!userSettings?.disableAutoPlayOrderRemarkVoice}
              onSwitchChange={value =>
                updateUserSettings({
                  disableAutoPlayOrderRemarkVoice: !value,
                })
              }
              switchStyle={{ marginRight: rpx(10) }}
            />

            <Cell
              title="静音模式下仍播报服务备注"
              isSwitch
              switchOn={userSettings?.playOrderRemarkVoiceInSilentMode === true}
              onSwitchChange={value =>
                updateUserSettings({
                  playOrderRemarkVoiceInSilentMode: value,
                })
              }
              switchStyle={{ marginRight: rpx(10) }}
            />
          </Section>
        </TableView>
      </ScrollView>
    );
  },
  { title: '通用设置' },
);
